// extracted by mini-css-extract-plugin
module.exports = {"list":"ProductGrid_list__sS4L9"};